export const EmptyContent = (
  <div className="py-10 text-center text-xs text-gray-400">
    Không có thông báo
  </div>
);
